import { Checkbox, FormControlLabel, Typography } from '@mui/material';

export interface CompositeCheckBoxType {
  info: {
    description: string;
    selectionChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    checkBoxStyle: {
      checkBoxBorderColor: string;
      checkBoxSelectedColor: string;
    };
    descriptionStyle: Record<string, unknown>;
  };
}

export const CompositeCheckBox = (props: CompositeCheckBoxType) => {
  return (
    <FormControlLabel
      value="female"
      control={
        <Checkbox
          onChange={props.info.selectionChangeHandler}
          disableRipple
          sx={{
            color: props.info.checkBoxStyle.checkBoxBorderColor,
            '&.Mui-checked': {
              color: props.info.checkBoxStyle.checkBoxSelectedColor,
            },
          }}
        />
      }
      label={<Typography sx={{ ...props.info.descriptionStyle }}>{props.info.description}</Typography>}
    />
  );
};
